export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const READ_CUSTOMER = 'READ_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER';
export const GET_TRACKING_BY_ID = 'GET_TRACKING_BY_ID';
export const GET_ALL_TRACKINGS = 'GET_ALL_TRACKINGS';
export const CLEAR_STATE = 'CLEAR_STATE';
